import { ReactQueryDevtools as ReactQueryDevtoolsOriginal } from '@tanstack/react-query-devtools';
import React, { useEffect, useState } from 'react';

const ReactQueryDevtoolsProduction = React.lazy(() =>
  import('@tanstack/react-query-devtools/build/modern/production.js').then((d) => ({
    default: d.ReactQueryDevtools,
  })),
);

export const ReactQueryDevtools = () => {
  const [showDevtools, setShowDevtools] = useState(false);

  useEffect(() => {
    // Check if we are in production(don't get confused, it will show in dev/staging/preview links as well) and the flag is set
    // We use strict equality for 'true' string
    if (process.env.NODE_ENV === 'production' && window.localStorage.getItem('fblFEDev') === 'true') {
      setShowDevtools(true);
    }
  }, []);

  // In development, show standard devtools immediately
  if (process.env.NODE_ENV === 'development') {
    return <ReactQueryDevtoolsOriginal initialIsOpen={false} buttonPosition="bottom-left" />;
  }

  // In production, conditionally show lazy-loaded devtools
  if (showDevtools) {
    return (
      <React.Suspense fallback={null}>
        <ReactQueryDevtoolsProduction initialIsOpen={false} buttonPosition="bottom-left" />
      </React.Suspense>
    );
  }

  return null;
};
